// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdsPreviewController from "./ads_preview_controller"
application.register("ads-preview", AdsPreviewController)

import AdsSlotRadiosController from "./ads_slot_radios_controller"
application.register("ads-slot-radios", AdsSlotRadiosController)

import AiAssistController from "./ai_assist_controller"
application.register("ai-assist", AiAssistController)

import AirbRevealController from "./airb_reveal_controller"
application.register("airb-reveal", AirbRevealController)

import AirtFaqController from "./airt_faq_controller"
application.register("airt-faq", AirtFaqController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import ApplyConfirmController from "./apply_confirm_controller"
application.register("apply-confirm", ApplyConfirmController)

import AtsCoverLetterController from "./ats_cover_letter_controller"
application.register("ats-cover-letter", AtsCoverLetterController)

import AtsEnrichmentController from "./ats_enrichment_controller"
application.register("ats-enrichment", AtsEnrichmentController)

import AtsJdMatchController from "./ats_jd_match_controller"
application.register("ats-jd-match", AtsJdMatchController)

import AtsJobDescriptionController from "./ats_job_description_controller"
application.register("ats-job-description", AtsJobDescriptionController)

import AtsOptimizerController from "./ats_optimizer_controller"
application.register("ats-optimizer", AtsOptimizerController)

import AtsOutreachController from "./ats_outreach_controller"
application.register("ats-outreach", AtsOutreachController)

import AtsPanelController from "./ats_panel_controller"
application.register("ats-panel", AtsPanelController)

import AtsPreviewTabsController from "./ats_preview_tabs_controller"
application.register("ats-preview-tabs", AtsPreviewTabsController)

import AtsResumeLibraryController from "./ats_resume_library_controller"
application.register("ats-resume-library", AtsResumeLibraryController)

import AtsTemplatePickerController from "./ats_template_picker_controller"
application.register("ats-template-picker", AtsTemplatePickerController)

import AutobotConfigController from "./autobot_config_controller"
application.register("autobot-config", AutobotConfigController)

import AutobotRecordingModalController from "./autobot_recording_modal_controller"
application.register("autobot-recording-modal", AutobotRecordingModalController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import AvatarFieldController from "./avatar_field_controller"
application.register("avatar-field", AvatarFieldController)

import BenefitsController from "./benefits_controller"
application.register("benefits", BenefitsController)

import BundleModalController from "./bundle_modal_controller"
application.register("bundle-modal", BundleModalController)

import BundlePricingController from "./bundle_pricing_controller"
application.register("bundle-pricing", BundlePricingController)

import CandidateFiltersController from "./candidate_filters_controller"
application.register("candidate-filters", CandidateFiltersController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatWhitepaperController from "./chat_whitepaper_controller"
application.register("chat-whitepaper", ChatWhitepaperController)

import ChipSelectController from "./chip_select_controller"
application.register("chip-select", ChipSelectController)

import ClearController from "./clear_controller"
application.register("clear", ClearController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CompanyClaimController from "./company_claim_controller"
application.register("company-claim", CompanyClaimController)

import CompanyProfileController from "./company_profile_controller"
application.register("company-profile", CompanyProfileController)

import ContentAnalyzerController from "./content_analyzer_controller"
application.register("content-analyzer", ContentAnalyzerController)

import CoverLetterBuilderController from "./cover_letter_builder_controller"
application.register("cover-letter-builder", CoverLetterBuilderController)

import CreateResumeController from "./create_resume_controller"
application.register("create-resume", CreateResumeController)

import InterviewLauncherController from "./interview_launcher_controller"
application.register("interview-launcher", InterviewLauncherController)

import DashboardDocsTabsController from "./dashboard_docs_tabs_controller"
application.register("dashboard-docs-tabs", DashboardDocsTabsController)

import DisableController from "./disable_controller"
application.register("disable", DisableController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmailSuggestionsController from "./email_suggestions_controller"
application.register("email-suggestions", EmailSuggestionsController)

import EmployerSearchController from "./employer_search_controller"
application.register("employer-search", EmployerSearchController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ExperienceScoreController from "./experience_score_controller"
application.register("experience-score", ExperienceScoreController)

import ExperienceToggleController from "./experience_toggle_controller"
application.register("experience-toggle", ExperienceToggleController)

import FilterLoadingController from "./filter_loading_controller"
application.register("filter-loading", FilterLoadingController)

import HeaderStylingController from "./header_styling_controller"
application.register("header-styling", HeaderStylingController)

import ImageFallbackController from "./image_fallback_controller"
application.register("image-fallback", ImageFallbackController)

import JobDescriptionController from "./job_description_controller"
application.register("job-description", JobDescriptionController)

import JobFiltersController from "./job_filters_controller"
application.register("job-filters", JobFiltersController)

import KanbanController from "./kanban_controller"
application.register("kanban", KanbanController)

import LinkedinImportController from "./linkedin_import_controller"
application.register("linkedin-import", LinkedinImportController)

import LoadMoreController from "./load_more_controller"
application.register("load-more", LoadMoreController)

import HelpTopicModalController from "./help_topic_modal_controller"
application.register("help-topic-modal", HelpTopicModalController)

import LiveVoiceController from "./live_voice_controller"
application.register("live-voice", LiveVoiceController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import NotificationPrefsController from "./notification_prefs_controller"
application.register("notification-prefs", NotificationPrefsController)

import PageFitController from "./page_fit_controller"
application.register("page-fit", PageFitController)

import ParsecvController from "./parsecv_controller"
application.register("parsecv", ParsecvController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import AboutTeamController from "./about_team_controller"
application.register("about-team", AboutTeamController)

import BlogAudioController from "./blog_audio_controller"
application.register("blog-audio", BlogAudioController)

import CareersEmbedController from "./careers_embed_controller"
application.register("careers-embed", CareersEmbedController)

import PlanTabsController from "./plan_tabs_controller"
application.register("plan-tabs", PlanTabsController)

import PodcastPlayerController from "./podcast_player_controller"
application.register("podcast-player", PodcastPlayerController)

import ProfileEditController from "./profile_edit_controller"
application.register("profile-edit", ProfileEditController)

import AutobotRunController from "./autobot_run_controller"
application.register("autobot-run", AutobotRunController)

import ResignationLetterBuilderController from "./resignation_letter_builder_controller"
application.register("resignation-letter-builder", ResignationLetterBuilderController)

import ResumeActionsController from "./resume_actions_controller"
application.register("resume-actions", ResumeActionsController)

import ResumeEditorController from "./resume_editor_controller"
application.register("resume-editor", ResumeEditorController)

import ResumeResizeController from "./resume_resize_controller"
application.register("resume-resize", ResumeResizeController)

import ResumeTabsController from "./resume_tabs_controller"
application.register("resume-tabs", ResumeTabsController)

import ResumeThumbnailController from "./resume_thumbnail_controller"
application.register("resume-thumbnail", ResumeThumbnailController)

import ResumeTranslatorController from "./resume_translator_controller"
application.register("resume-translator", ResumeTranslatorController)

import RichTextController from "./rich_text_controller"
application.register("rich-text", RichTextController)

import SalaryRangeController from "./salary_range_controller"
application.register("salary-range", SalaryRangeController)

import SidebarCollapseController from "./sidebar_collapse_controller"
application.register("sidebar-collapse", SidebarCollapseController)

import SidebarDrawerController from "./sidebar_drawer_controller"
application.register("sidebar-drawer", SidebarDrawerController)

import SidebarGroupController from "./sidebar_group_controller"
application.register("sidebar-group", SidebarGroupController)

import SkillChipsController from "./skill_chips_controller"
application.register("skill-chips", SkillChipsController)

import SortMenuController from "./sort_menu_controller"
application.register("sort-menu", SortMenuController)

import StickyApplyController from "./sticky_apply_controller"
application.register("sticky-apply", StickyApplyController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)

import TemplateGalleryController from "./template_gallery_controller"
application.register("template-gallery", TemplateGalleryController)

import TemplateModalController from "./template_modal_controller"
application.register("template-modal", TemplateModalController)

import TranslatorDemoController from "./translator_demo_controller"
application.register("translator-demo", TranslatorDemoController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)


import ViewModeController from "./view_mode_controller"
application.register("view-mode", ViewModeController)

import NotificationBellController from "./notification_bell_controller"
application.register("notification-bell", NotificationBellController)

import PodcastAutostartController from "./podcast_autostart_controller"
application.register("podcast-autostart", PodcastAutostartController)

import NotificationTabsController from "./notification_tabs_controller"
application.register("notification-tabs", NotificationTabsController)

import AppSearchController from "./app_search_controller"
application.register("app-search", AppSearchController)

import ExportMenuController from "./export_menu_controller"
application.register("export-menu", ExportMenuController)

import EmployerPulseController from "./employer_pulse_controller"
application.register("employer-pulse", EmployerPulseController)
